import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, theme } from '@sg/garnish';

import type {
  SweetpassBenefitsCta,
  SweetpassBenefitsPageUpgradeCtaHandler,
} from './SweetpassBenefitsScreen.loaded';

export const SweetpassBenefitsPageCtaContent = ({
  content,
  ctaHandler,
}: SweetpassBenefitsPageCtaContentProps) => {
  const onPress = useCallback(() => {
    ctaHandler(content.action);
  }, [content.action, ctaHandler]);

  return (
    <View style={styles.cta} key={content.id}>
      <View style={styles.alignItemsCenter}>
        <Button
          testID={`sweetpass-benefits-page-cta-${content.id}`}
          palette={content.palette}
          size="large"
          onPress={onPress}
        >
          {content.title}
        </Button>
      </View>
    </View>
  );
};

type SweetpassBenefitsPageCtaContentProps = {
  readonly content: SweetpassBenefitsCta;
  readonly ctaHandler: SweetpassBenefitsPageUpgradeCtaHandler;
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  alignItemsCenter: {
    alignItems: 'center',
  },
  cta: {
    paddingTop: theme.spacing.xlarge,
    paddingHorizontal: theme.spacing.medium,
  },
});
